import React from 'react';
import { Status } from '../types';
import { STATUS_LABEL } from '../utils/statusHelpers';
import './StatusBadge.scss';

interface StatusBadgeProps {
  status: Status;
}

export const StatusBadge: React.FC<StatusBadgeProps> = ({ status }) => (
  <span className={`status-badge status-badge--${status}`}>
    {STATUS_LABEL[status]}
  </span>
);
